<template>
  <v-data-table
    :headers="headers"
    :items="produtos.content"
    class="elevation-1 mt-2"
    :loading="loading"
    :server-items-length="produtos.total"
    @update:options="updateOptions"
    :footer-props="footerOptions"
    no-data-text="Nenhum produto encontrado"
    loading-text="Carregando produtos..."
    :options="optionsList"
  >
    <template v-slot:item.produto.codigo="{ item }">
      {{ item.produto.codigo ? item.produto.codigo : '-' }}
    </template>
    <template v-slot:item.produto.descricao="{ item }">
      <px-produto-descricao
        :show-codigo="false"
        :especificacao="item.especificacaoProdutoOrigem || item.especificacaoProduto"
        :produto="item.produto"/>
    </template>
    <template v-slot:item.quantidade="{ item }">
      {{
        item.quantidade
          | number(getCurrencyFormat(item))
      }}
      {{ item.unidadeMedida.descricao }}
    </template>
    <template v-slot:item.dataPrevisaoEntrega="{ item }">
      <px-getao-compra-previsao-entrega-edit
        v-if="hasRoleGestorEntrega"
        :compra-produto="item"
        @change="emitChange"/>
      <div v-else>
        {{ item.dataPrevisaoEntrega | date }}
      </div>
    </template>
    <template v-slot:item.situacaoEntrega="{ item }">
      <px-gestao-entrega-switch-entregue :compra-produto="item" @change="emitChange"/>
    </template>
    <template v-slot:item.compra="{ item }">
      <px-span-tooltip
        bottom
        :text="labelCompra(item.compra)"
        :tooltip="tooltipCompra(item.compra)"/>
      <v-btn icon small link target="_blank" :to="compraLink(item)">
        <v-icon small>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { CasaDecimalUtils } from 'px-components';
import { mapGetters } from 'vuex';
import GestaoEntregaSwitchEntregue from '@/modules/entregas/GestaoEntregaSwitchEntregue.vue';
import GetaoCompraPrevisaoEntregaEdit from './GetaoCompraPrevisaoEntregaEdit.vue';

export default {
  props: {
    value: Array,
    produtos: Object,
    loading: Boolean,
    optionsList: Object,
    footerOptions: Object,
    onChangeOptions: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Código',
          value: 'produto.codigo',
        },
        {
          text: 'Produto',
          value: 'produto.descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
        },
        {
          text: 'Data de entrega',
          value: 'dataPrevisaoEntrega',
        },
        {
          text: 'Situação',
          value: 'situacaoEntrega',
        },
        {
          text: 'Compra',
          value: 'compra',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleGestorEntrega']),
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    labelCompra() {
      return compra => (compra.codigoInterno ? `${compra.codigoInterno} / ${compra.id}` : compra.id);
    },
    tooltipCompra() {
      return compra => (compra.codigoInterno ? 'Pedido de OC gerada / Pedido Proxpect' : 'Pedido Proxpect');
    },
    getCurrencyFormat() {
      return (item) => {
        const casasDecimais = item.produto ? item.produto.casasDecimais : null;
        return CasaDecimalUtils.getCurrencyFormat(casasDecimais);
      };
    },
    compraLink() {
      return item => `/compra/${item.compra.id}/detalhes`;
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
  },
  components: {
    pxGestaoEntregaSwitchEntregue: GestaoEntregaSwitchEntregue,
    pxGetaoCompraPrevisaoEntregaEdit: GetaoCompraPrevisaoEntregaEdit,
  },
};
</script>
